export default __webpack_public_path__ + "static/media/divide_gray.aed79211.svg";